import React from "react";
import { SvgIcon } from "@mui/material";

const CrossIcon = ({
    width = "17",
    height = "17",
    viewBox = "0 0 17 17",
    fill = "#B50500",
    ...props
}) => (
    <SvgIcon
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none"
        sx={{ display: "block" }}
        {...props}
    >
        <g clipPath="url(#clip0_6180_96125)">
            <path
                d="M8.13745 0.274905C6.58239 0.274905 5.06224 0.736035 3.76926 1.59998C2.47627 2.46393 1.4685 3.69189 0.873407 5.12858C0.278309 6.56528 0.122604 8.14617 0.425982 9.67136C0.729361 11.1965 1.4782 12.5975 2.57779 13.6971C3.67739 14.7967 5.07836 15.5455 6.60354 15.8489C8.12873 16.1523 9.70963 15.9966 11.1463 15.4015C12.583 14.8064 13.811 13.7986 14.6749 12.5056C15.5389 11.2127 16 9.69252 16 8.13745C16.0008 7.10469 15.7981 6.08189 15.4032 5.12758C15.0084 4.17327 14.4293 3.30617 13.699 2.57589C12.9687 1.84562 12.1016 1.2665 11.1473 0.871671C10.193 0.476843 9.17022 0.274053 8.13745 0.274905ZM8.13745 14.15C6.94828 14.15 5.78582 13.7974 4.79707 13.1367C3.80831 12.476 3.03767 11.537 2.58259 10.4383C2.12752 9.3397 2.00845 8.13078 2.24045 6.96446C2.47244 5.79815 3.04508 4.72681 3.88595 3.88595C4.72682 3.04508 5.79815 2.47244 6.96446 2.24045C8.13078 2.00845 9.3397 2.12752 10.4383 2.58259C11.537 3.03767 12.476 3.80831 13.1367 4.79707C13.7974 5.78582 14.15 6.94828 14.15 8.13745C14.1516 8.92747 13.9971 9.71003 13.6955 10.4402C13.3939 11.1704 12.9511 11.8339 12.3925 12.3925C11.8339 12.9511 11.1704 13.3939 10.4402 13.6955C9.71003 13.9971 8.92747 14.1516 8.13745 14.15Z"
                fill={fill}
            />
            <path
                d="M10.7736 5.73244C10.6901 5.64479 10.5896 5.57501 10.4783 5.52734C10.367 5.47966 10.2472 5.45508 10.1261 5.45508C10.0051 5.45508 9.88523 5.47966 9.77393 5.52734C9.66263 5.57501 9.56217 5.64479 9.47863 5.73244L8.13737 7.0737L6.84236 5.77869C6.67004 5.60982 6.43804 5.51577 6.19678 5.51699C5.95551 5.51821 5.72447 5.61459 5.55386 5.7852C5.38326 5.9558 5.28687 6.18684 5.28566 6.42811C5.28444 6.66938 5.37848 6.90138 5.54736 7.0737L6.84236 8.36871L5.54736 9.66371C5.37848 9.83603 5.28444 10.068 5.28566 10.3093C5.28687 10.5506 5.38326 10.7816 5.55386 10.9522C5.72447 11.1228 5.95551 11.2192 6.19678 11.2204C6.43804 11.2216 6.67004 11.1276 6.84236 10.9587L8.13737 9.66371L9.43238 10.9587C9.6047 11.1276 9.8367 11.2216 10.078 11.2204C10.3192 11.2192 10.5503 11.1228 10.7209 10.9522C10.8915 10.7816 10.9879 10.5506 10.9891 10.3093C10.9903 10.068 10.8963 9.83603 10.7274 9.66371L9.43238 8.36871L10.7274 7.0737C10.9008 6.89609 11.0017 6.66012 11.0102 6.41203C11.0188 6.16393 10.9344 5.92158 10.7736 5.73244Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_6180_96125">
                <rect width="17" height="17" fill="white" />
            </clipPath>
        </defs>
    </SvgIcon>
);

export default CrossIcon;
